import { observer } from 'mobx-react';
import React, { Fragment } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import LoadingOverlay from '../LoadingOverlay';
import UpdateTrapsMap from '../maps/UpdateTrapsMap';
import TrapForm from './TrapForm';

function TrapModalContent({
  selectedDatabase,
  bearerToken,
  refreshBearerToken,
  type,
  fProps,
  trapCoords,
  setTrapCoords,
  map,
  chargedInput,
}) {
  return (
    <Fragment>
      <TrapForm
        {...fProps}
        trapCoords={trapCoords}
        setTrapCoords={setTrapCoords}
        chargedInput={chargedInput}
        map={map}
      />
      {map && (
        <Row style={{height: '300px'}}>
          <Col>
            <UpdateTrapsMap
              selectedDatabase={selectedDatabase}
              bearerToken={bearerToken}
              refreshBearerToken={refreshBearerToken}
              updateType={type}
              trapCoords={trapCoords}
              setTrapCoords={setTrapCoords}
              trappingZoneName={fProps.values.trappingZone.label || 'All'}
            />
          </Col>
        </Row>
      )}
      {!trapCoords ? null : !trapCoords.valid ? (
        <p className='text-warning'>
          {`Warning: The trap is placed outside production site ${trapCoords.currentZone}`}
        </p>
      ) : (
        <div style={{ paddingTop: '40px' }}></div>
      )}
      <Button varient='primary' type='button' onClick={fProps.handleSubmit}>
        Submit
      </Button>
      {fProps.isSubmitting ? <LoadingOverlay /> : null}
    </Fragment>
  );
}

export default observer(TrapModalContent);
